import * as React from 'react';
import { SelectChangeEvent } from '@mui/material';
import { Select } from 'components';
import { TProductsSortDropdown } from './ProductsSortDropdown.types';
import { PRODUCTS_SORT_OPTIONS } from './ProductsSortDropdown.constants';
import './ProductsSortDropdown.styled.scss';

export const ProductsSortDropdown: TProductsSortDropdown = ({
  onSortChange,
  defaultSortBy = 'default',
}) => {
  const [sortBy, setSortBy] = React.useState(defaultSortBy);

  const handleChange = (event: SelectChangeEvent) => {
    setSortBy(event.target.value);
    onSortChange(event.target.value);
  };

  return (
    <Select
      labelId="sort-select-label"
      id="sort-select"
      value={sortBy}
      label="Сортувати"
      size="small"
      onChange={handleChange}
      minWidth="200px"
      maxWidth="100%"
      className="products-sort-dropdown__select"
      options={PRODUCTS_SORT_OPTIONS.map((option) => ({
        id: option.value,
        label: option.label,
      }))}
    />
  );
};
